import { useGetDissaprobalReasonQuery } from '../services/swarmsApi';

export const useDisapprovalReasons = () => {
  const { data: disapprovalReasons, isLoading, error } = useGetDissaprobalReasonQuery();

  const getDisapprovalReasonName = (disapprovalReasonId) => {
    if (!disapprovalReasons || isLoading) return '';
    const reason = disapprovalReasons.find(reason => reason.id === disapprovalReasonId);
    return reason ? reason.name : '';
  };

  return {
    disapprovalReasons,
    isLoading,
    error,
    getDisapprovalReasonName
  };
};
